module.exports = __webpack_public_path__ + "img/RiVAITechnology.b3278a1f.jpg";